// AUTO-GENERATED from '2026 Placed Students.xlsx' + the Students Photo zip.
// Student photos are optimised WebP in public/images/placements-page/placed_students/
// (matched by name+USN, with a few hand-fixed names); students without a photo
// fall back to initials in the UI.
export const successStories = {
  "emmvee": {
    "company": "EMMVEE",
    "logo": "/images/placements-page/company_logos/emmvee.webp",
    "studentCount": "52 Students Placed",
    "package": "3.2 LPA",
    "students": [
      {
        "name": "Akash Kumar N S",
        "branch": "ECE",
        "role": "Trainee",
        "package": "3.2 LPA",
        "img": null
      },
      {
        "name": "Ankitha S",
        "branch": "ECE",
        "role": "Trainee",
        "package": "3.2 LPA",
        "img": null
      },
      {
        "name": "B Mohan Krishna",
        "branch": "ECE",
        "role": "Trainee",
        "package": "3.2 LPA",
        "img": null
      },
      {
        "name": "Bhumika R Talawar",
        "branch": "ECE",
        "role": "Trainee",
        "package": "3.2 LPA",
        "img": null
      },
      {
        "name": "Chandana B",
        "branch": "ECE",
        "role": "Trainee",
        "package": "3.2 LPA",
        "img": null
      },
      {
        "name": "Chandana H N",
        "branch": "ECE",
        "role": "Trainee",
        "package": "3.2 LPA",
        "img": null
      },
      {
        "name": "Charan S",
        "branch": "ECE",
        "role": "Trainee",
        "package": "3.2 LPA",
        "img": null
      },
      {
        "name": "Charitha G S",
        "branch": "ECE",
        "role": "Trainee",
        "package": "3.2 LPA",
        "img": null
      },
      {
        "name": "D Anjali",
        "branch": "ECE",
        "role": "Trainee",
        "package": "3.2 LPA",
        "img": null
      },
      {
        "name": "Hariprasad N G",
        "branch": "ECE",
        "role": "Trainee",
        "package": "3.2 LPA",
        "img": null
      },
      {
        "name": "Ishwarya M",
        "branch": "ECE",
        "role": "Trainee",
        "package": "3.2 LPA",
        "img": null
      },
      {
        "name": "Katyayanamaradi Manjunatha",
        "branch": "ECE",
        "role": "Trainee",
        "package": "3.2 LPA",
        "img": null
      },
      {
        "name": "Kavya Patil K M",
        "branch": "ECE",
        "role": "Trainee",
        "package": "3.2 LPA",
        "img": null
      },
      {
        "name": "Kubra Noorian A",
        "branch": "ECE",
        "role": "Trainee",
        "package": "3.2 LPA",
        "img": null
      },
      {
        "name": "K Krishna",
        "branch": "ECE",
        "role": "Trainee",
        "package": "3.2 LPA",
        "img": null
      },
      {
        "name": "Lekhana K R",
        "branch": "ECE",
        "role": "Trainee",
        "package": "3.2 LPA",
        "img": null
      },
      {
        "name": "Lohith S",
        "branch": "ECE",
        "role": "Trainee",
        "package": "3.2 LPA",
        "img": null
      },
      {
        "name": "Manish S",
        "branch": "ECE",
        "role": "Trainee",
        "package": "3.2 LPA",
        "img": null
      },
      {
        "name": "Monika S V",
        "branch": "ECE",
        "role": "Trainee",
        "package": "3.2 LPA",
        "img": null
      },
      {
        "name": "Mumegowda G N",
        "branch": "ECE",
        "role": "Trainee",
        "package": "3.2 LPA",
        "img": null
      },
      {
        "name": "Narendra R N",
        "branch": "ECE",
        "role": "Trainee",
        "package": "3.2 LPA",
        "img": null
      },
      {
        "name": "Narendra S",
        "branch": "ECE",
        "role": "Trainee",
        "package": "3.2 LPA",
        "img": null
      },
      {
        "name": "Navyashree",
        "branch": "ECE",
        "role": "Trainee",
        "package": "3.2 LPA",
        "img": null
      },
      {
        "name": "Prajwal V",
        "branch": "ECE",
        "role": "Trainee",
        "package": "3.2 LPA",
        "img": null
      },
      {
        "name": "Prajwal V D",
        "branch": "ECE",
        "role": "Trainee",
        "package": "3.2 LPA",
        "img": null
      },
      {
        "name": "Pratheeksha S L Gowda",
        "branch": "ECE",
        "role": "Trainee",
        "package": "3.2 LPA",
        "img": null
      },
      {
        "name": "Priyanka C K",
        "branch": "ECE",
        "role": "Trainee",
        "package": "3.2 LPA",
        "img": null
      },
      {
        "name": "Priyanka M",
        "branch": "ECE",
        "role": "Trainee",
        "package": "3.2 LPA",
        "img": null
      },
      {
        "name": "Rachana A",
        "branch": "ECE",
        "role": "Trainee",
        "package": "3.2 LPA",
        "img": null
      },
      {
        "name": "Sahana Yaxambi",
        "branch": "ECE",
        "role": "Trainee",
        "package": "3.2 LPA",
        "img": null
      },
      {
        "name": "Sai Deepthi M",
        "branch": "ECE",
        "role": "Trainee",
        "package": "3.2 LPA",
        "img": null
      },
      {
        "name": "Sanjay H C",
        "branch": "ECE",
        "role": "Trainee",
        "package": "3.2 LPA",
        "img": null
      },
      {
        "name": "Shashidhar Ramaraddi Inamati",
        "branch": "ECE",
        "role": "Trainee",
        "package": "3.2 LPA",
        "img": null
      },
      {
        "name": "Shraddha S",
        "branch": "ECE",
        "role": "Trainee",
        "package": "3.2 LPA",
        "img": null
      },
      {
        "name": "Siddu Parashuram Kenginal",
        "branch": "ECE",
        "role": "Trainee",
        "package": "3.2 LPA",
        "img": null
      },
      {
        "name": "Sirisha V",
        "branch": "ECE",
        "role": "Trainee",
        "package": "3.2 LPA",
        "img": null
      },
      {
        "name": "Soujanya T R",
        "branch": "ECE",
        "role": "Trainee",
        "package": "3.2 LPA",
        "img": null
      },
      {
        "name": "Srujan Raj N S",
        "branch": "ECE",
        "role": "Trainee",
        "package": "3.2 LPA",
        "img": null
      },
      {
        "name": "Sumana Shree C S",
        "branch": "ECE",
        "role": "Trainee",
        "package": "3.2 LPA",
        "img": null
      },
      {
        "name": "Vaddi Hemanth Reddy",
        "branch": "ECE",
        "role": "Trainee",
        "package": "3.2 LPA",
        "img": null
      },
      {
        "name": "Varshini M S",
        "branch": "ECE",
        "role": "Trainee",
        "package": "3.2 LPA",
        "img": null
      },
      {
        "name": "Varshitha R",
        "branch": "ECE",
        "role": "Trainee",
        "package": "3.2 LPA",
        "img": null
      },
      {
        "name": "Vidyashree Umanabadi",
        "branch": "ECE",
        "role": "Trainee",
        "package": "3.2 LPA",
        "img": null
      },
      {
        "name": "Harshith Gowda T D",
        "branch": "ECE",
        "role": "Trainee",
        "package": "3.2 LPA",
        "img": null
      },
      {
        "name": "Prajwal R",
        "branch": "ECE",
        "role": "Trainee",
        "package": "3.2 LPA",
        "img": null
      },
      {
        "name": "Shridhar Biradar",
        "branch": "ECE",
        "role": "Trainee",
        "package": "3.2 LPA",
        "img": null
      },
      {
        "name": "Vishwas Machenahalli",
        "branch": "ECE",
        "role": "Trainee",
        "package": "3.2 LPA",
        "img": null
      },
      {
        "name": "Tejas",
        "branch": "ECE",
        "role": "Trainee",
        "package": "3.2 LPA",
        "img": null
      },
      {
        "name": "Matteddula Thanulatha",
        "branch": "ECE",
        "role": "Trainee",
        "package": "3.2 LPA",
        "img": null
      },
      {
        "name": "Matteddula Umapriya",
        "branch": "ECE",
        "role": "Trainee",
        "package": "3.2 LPA",
        "img": null
      },
      {
        "name": "M Y Viswanath Reddy",
        "branch": "ECE",
        "role": "Trainee",
        "package": "3.2 LPA",
        "img": null
      },
      {
        "name": "Harisha M",
        "branch": "ECE",
        "role": "Trainee",
        "package": "3.2 LPA",
        "img": null
      }
    ]
  },
  "247ai": {
    "company": "[24]7.ai",
    "logo": "/images/placements-page/company_logos/247-ai.webp",
    "studentCount": "21 Students Placed",
    "package": "3.5 LPA",
    "students": [
      {
        "name": "Adithya K V",
        "branch": "CSE - AI ML",
        "role": "Digital Associate",
        "package": "3.5 LPA",
        "img": "/images/placements-page/placed_students/1nc22ci002.webp"
      },
      {
        "name": "Suhana Anjum",
        "branch": "CSE",
        "role": "Digital Associate",
        "package": "3.5 LPA",
        "img": "/images/placements-page/placed_students/1nc22cs163.webp"
      },
      {
        "name": "R Manjunath",
        "branch": "CSE - DS",
        "role": "Digital Associate",
        "package": "3.5 LPA",
        "img": "/images/placements-page/placed_students/1nc22cd041.webp"
      },
      {
        "name": "B. Mohankrishna",
        "branch": "ECE",
        "role": "Digital Associate",
        "package": "3.5 LPA",
        "img": "/images/placements-page/placed_students/1nc22ec014.webp"
      },
      {
        "name": "VINAY KUMAR",
        "branch": "CSE - DS",
        "role": "Digital Associate",
        "package": "3.5 LPA",
        "img": "/images/placements-page/placed_students/1nc22cd062.webp"
      },
      {
        "name": "Vaibhav biradar",
        "branch": "ECE",
        "role": "Digital Associate",
        "package": "3.5 LPA",
        "img": "/images/placements-page/placed_students/1nc22ec115.webp"
      },
      {
        "name": "Saleha Farheen",
        "branch": "ISE",
        "role": "Digital Associate",
        "package": "3.5 LPA",
        "img": "/images/placements-page/placed_students/1nc22is048.webp"
      },
      {
        "name": "Afreen Taj S",
        "branch": "CSE",
        "role": "Digital Associate",
        "package": "3.5 LPA",
        "img": "/images/placements-page/placed_students/1nc22cs005.webp"
      },
      {
        "name": "Deepika T E",
        "branch": "CSE",
        "role": "Digital Associate",
        "package": "3.5 LPA",
        "img": "/images/placements-page/placed_students/1nc22cs041.webp"
      },
      {
        "name": "Soujanya TR",
        "branch": "ECE",
        "role": "Digital Associate",
        "package": "3.5 LPA",
        "img": "/images/placements-page/placed_students/1nc22ec102.webp"
      },
      {
        "name": "Deekshitha k",
        "branch": "CSE",
        "role": "Digital Associate",
        "package": "3.5 LPA",
        "img": "/images/placements-page/placed_students/1nc22cs038.webp"
      },
      {
        "name": "Sneha B Gudi",
        "branch": "CSE",
        "role": "Digital Associate",
        "package": "3.5 LPA",
        "img": "/images/placements-page/placed_students/1nc22cs157.webp"
      },
      {
        "name": "Shreya S",
        "branch": "CSE",
        "role": "Digital Associate",
        "package": "3.5 LPA",
        "img": "/images/placements-page/placed_students/1nc22cs151.webp"
      },
      {
        "name": "Azizon Firdoz",
        "branch": "CSE - DS",
        "role": "Digital Associate",
        "package": "3.5 LPA",
        "img": "/images/placements-page/placed_students/1nc22cd047.webp"
      },
      {
        "name": "Rakesh Krishna",
        "branch": "ECE",
        "role": "Digital Associate",
        "package": "3.5 LPA",
        "img": "/images/placements-page/placed_students/1nc22ec085.webp"
      },
      {
        "name": "Shahabaz H",
        "branch": "ISE",
        "role": "Digital Associate",
        "package": "3.5 LPA",
        "img": "/images/placements-page/placed_students/1nc22is050.webp"
      },
      {
        "name": "Darshan P",
        "branch": "CSE",
        "role": "Digital Associate",
        "package": "3.5 LPA",
        "img": "/images/placements-page/placed_students/1nc22cs036.webp"
      },
      {
        "name": "Charitha GS",
        "branch": "ECE",
        "role": "Digital Associate",
        "package": "3.5 LPA",
        "img": "/images/placements-page/placed_students/1nc22ec021.webp"
      },
      {
        "name": "Rashmi M",
        "branch": "CSE - AI ML",
        "role": "Digital Associate",
        "package": "3.5 LPA",
        "img": "/images/placements-page/placed_students/1nc22ci047.webp"
      },
      {
        "name": "Gaganashree A",
        "branch": "ISE",
        "role": "Digital Associate",
        "package": "3.5 LPA",
        "img": "/images/placements-page/placed_students/1nc22is015.webp"
      },
      {
        "name": "Anusha V",
        "branch": "ISE",
        "role": "Digital Associate",
        "package": "3.5 LPA",
        "img": "/images/placements-page/placed_students/1nc22is006.webp"
      }
    ]
  },
  "deloitte": {
    "company": "Deloitte",
    "logo": "/images/placements-page/company_logos/deloitte.webp",
    "studentCount": "12 Students Placed",
    "package": "3.57 LPA",
    "students": [
      {
        "name": "Keerthana G V",
        "branch": "CSE",
        "role": "Analyst",
        "package": "3.57 LPA",
        "img": "/images/placements-page/placed_students/1nc22cs077.webp"
      },
      {
        "name": "Tejas R C",
        "branch": "CSE",
        "role": "Analyst",
        "package": "3.57 LPA",
        "img": "/images/placements-page/placed_students/1nc22cs168.webp"
      },
      {
        "name": "Tamanna H S",
        "branch": "CSE",
        "role": "Analyst",
        "package": "3.57 LPA",
        "img": "/images/placements-page/placed_students/1nc22cs167.webp"
      },
      {
        "name": "Mithun R",
        "branch": "ISE",
        "role": "Analyst",
        "package": "3.57 LPA",
        "img": "/images/placements-page/placed_students/1nc22is034.webp"
      },
      {
        "name": "Paruchuri Khyathi",
        "branch": "CSE",
        "role": "Analyst",
        "package": "3.57 LPA",
        "img": "/images/placements-page/placed_students/1nc22cs109.webp"
      },
      {
        "name": "DEVINENI JANYUSREE",
        "branch": "CSE",
        "role": "Analyst",
        "package": "3.57 LPA",
        "img": "/images/placements-page/placed_students/1nc22cs042.webp"
      },
      {
        "name": "K.Adithya Vardhan Reddy",
        "branch": "ECE",
        "role": "Analyst",
        "package": "3.57 LPA",
        "img": "/images/placements-page/placed_students/adithya-vardhan-reddy.webp"
      },
      {
        "name": "Maulya Naik",
        "branch": "CSE",
        "role": "Analyst",
        "package": "3.57 LPA",
        "img": "/images/placements-page/placed_students/1nc22cs092.webp"
      },
      {
        "name": "Muddarasappagari Sravanthi",
        "branch": "ISE",
        "role": "Analyst",
        "package": "3.57 LPA",
        "img": "/images/placements-page/placed_students/1nc22is036.webp"
      },
      {
        "name": "Pooja G J",
        "branch": "CSE",
        "role": "Analyst",
        "package": "3.57 LPA",
        "img": "/images/placements-page/placed_students/1nc22cs113.webp"
      },
      {
        "name": "Shashidhar S B",
        "branch": "ISE",
        "role": "Analyst",
        "package": "3.57 LPA",
        "img": "/images/placements-page/placed_students/shashidhar-sb.webp"
      },
      {
        "name": "Swaroop Patil",
        "branch": "ISE",
        "role": "Analyst",
        "package": "3.57 LPA",
        "img": "/images/placements-page/placed_students/1nc22is057.webp"
      }
    ]
  },
  "sagility": {
    "company": "Sagility",
    "logo": "/images/placements-page/company_logos/sagility.webp",
    "studentCount": "10 Students Placed",
    "package": "6 LPA",
    "students": [
      {
        "name": "N.Saisree",
        "branch": "CSE - AI ML",
        "role": "Data Analyst / Software Engineer",
        "package": "6 LPA",
        "img": "/images/placements-page/placed_students/saisree.webp"
      },
      {
        "name": "Gowri P Gowda",
        "branch": "CSE",
        "role": "Data Analyst / Software Engineer",
        "package": "6 LPA",
        "img": "/images/placements-page/placed_students/1nc22cs052.webp"
      },
      {
        "name": "Harsha Vardhana S",
        "branch": "ISE",
        "role": "Data Analyst / Software Engineer",
        "package": "6 LPA",
        "img": "/images/placements-page/placed_students/1nc22is017.webp"
      },
      {
        "name": "Archana K B",
        "branch": "CSE",
        "role": "Data Analyst / Software Engineer",
        "package": "6 LPA",
        "img": "/images/placements-page/placed_students/1nc22cs013.webp"
      },
      {
        "name": "Sohan Kumar R",
        "branch": "CSE",
        "role": "Data Analyst / Software Engineer",
        "package": "6 LPA",
        "img": "/images/placements-page/placed_students/1nc22cs159.webp"
      },
      {
        "name": "Vindya",
        "branch": "CSE - DS",
        "role": "Data Analyst / Software Engineer",
        "package": "6 LPA",
        "img": "/images/placements-page/placed_students/vindya.webp"
      },
      {
        "name": "Tushar Pandey",
        "branch": "CSE",
        "role": "Data Analyst / Software Engineer",
        "package": "6 LPA",
        "img": "/images/placements-page/placed_students/1nc22cs170.webp"
      },
      {
        "name": "Shreyas T V",
        "branch": "CSE",
        "role": "Data Analyst / Software Engineer",
        "package": "6 LPA",
        "img": "/images/placements-page/placed_students/1nc22cs152.webp"
      },
      {
        "name": "Satvik varun",
        "branch": "CSE - AI ML",
        "role": "Data Analyst / Software Engineer",
        "package": "6 LPA",
        "img": "/images/placements-page/placed_students/1nc22ci053.webp"
      },
      {
        "name": "Megharaj T Shediyannanavar",
        "branch": "CSE",
        "role": "Data Analyst / Software Engineer",
        "package": "6 LPA",
        "img": "/images/placements-page/placed_students/1nc22cs094.webp"
      }
    ]
  },
  "assistoai": {
    "company": "Assisto AI",
    "logo": "/images/placements-page/company_logos/assisto.webp",
    "studentCount": "9 Students Placed",
    "package": "6 LPA",
    "students": [
      {
        "name": "Pavitra Dugani",
        "branch": "CSE",
        "role": "Developer",
        "package": "6 LPA",
        "img": "/images/placements-page/placed_students/1nc22cs111.webp"
      },
      {
        "name": "Swaroop Patil",
        "branch": "ISE",
        "role": "Developer",
        "package": "6 LPA",
        "img": "/images/placements-page/placed_students/1nc22is057.webp"
      },
      {
        "name": "Koduru Guru Sathvik",
        "branch": "CSE - AI ML",
        "role": "Developer",
        "package": "6 LPA",
        "img": "/images/placements-page/placed_students/1nc22ci027.webp"
      },
      {
        "name": "Mourya M",
        "branch": "CSE",
        "role": "Developer",
        "package": "6 LPA",
        "img": "/images/placements-page/placed_students/1nc22cs100.webp"
      },
      {
        "name": "Deeksha G",
        "branch": "CSE",
        "role": "Developer",
        "package": "6 LPA",
        "img": "/images/placements-page/placed_students/1nc22cs037.webp"
      },
      {
        "name": "Sanket Dharmanna Kerannavar",
        "branch": "CSE",
        "role": "Developer",
        "package": "6 LPA",
        "img": "/images/placements-page/placed_students/1nc22cs141.webp"
      },
      {
        "name": "Priyanshu Soni",
        "branch": "CSE",
        "role": "AI Engineer",
        "package": "6 LPA",
        "img": "/images/placements-page/placed_students/1nc22cs123.webp"
      },
      {
        "name": "Darshan P",
        "branch": "CSE",
        "role": "AI Engineer",
        "package": "6 LPA",
        "img": "/images/placements-page/placed_students/1nc22cs036.webp"
      },
      {
        "name": "Vivek S",
        "branch": "CSE",
        "role": "AI Engineer",
        "package": "6 LPA",
        "img": "/images/placements-page/placed_students/vivek-s.webp"
      }
    ]
  },
  "ideainfinity": {
    "company": "Idea Infinity",
    "logo": "/images/placements-page/company_logos/idea-infinity.webp",
    "studentCount": "7 Students Placed",
    "package": "5 LPA",
    "students": [
      {
        "name": "Raja N",
        "branch": "CSE",
        "role": "Associate Software Engineer",
        "package": "5 LPA",
        "img": "/images/placements-page/placed_students/1nc22cs126.webp"
      },
      {
        "name": "kavana .S",
        "branch": "CSE",
        "role": "Associate Software Engineer",
        "package": "5 LPA",
        "img": "/images/placements-page/placed_students/1nc22cs074.webp"
      },
      {
        "name": "Manoj M V",
        "branch": "CSE - DS",
        "role": "Associate Software Engineer",
        "package": "5 LPA",
        "img": "/images/placements-page/placed_students/1nc22cd026.webp"
      },
      {
        "name": "Sanket Dharmanna Kerannavar",
        "branch": "CSE",
        "role": "Associate Software Engineer",
        "package": "5 LPA",
        "img": "/images/placements-page/placed_students/1nc22cs141.webp"
      },
      {
        "name": "Sudeep Kumar SM",
        "branch": "CSE",
        "role": "Associate Software Engineer",
        "package": "5 LPA",
        "img": "/images/placements-page/placed_students/1nc22cs162.webp"
      },
      {
        "name": "Suhana S",
        "branch": "CSE",
        "role": "Associate Software Engineer",
        "package": "5 LPA",
        "img": "/images/placements-page/placed_students/1nc22cs164.webp"
      },
      {
        "name": "Shah Alam",
        "branch": "CSE",
        "role": "Associate Software Engineer",
        "package": "5 LPA",
        "img": "/images/placements-page/placed_students/1nc22cs145.webp"
      }
    ]
  },
  "mphasis": {
    "company": "Mphasis",
    "logo": "/images/placements-page/company_logos/mphasis.webp",
    "studentCount": "6 Students Placed",
    "package": "7.5 LPA",
    "students": [
      {
        "name": "Mithun R",
        "branch": "ISE",
        "role": "Technology Consulting",
        "package": "7.5 LPA",
        "img": "/images/placements-page/placed_students/1nc22is034.webp"
      },
      {
        "name": "Akhil Samrat H K",
        "branch": "CSE",
        "role": "Technology Consulting",
        "package": "7.5 LPA",
        "img": "/images/placements-page/placed_students/1nc22cs006.webp"
      },
      {
        "name": "Saksham Srivastava",
        "branch": "CSE",
        "role": "Technology Consulting",
        "package": "7.5 LPA",
        "img": "/images/placements-page/placed_students/1nc22cs191.webp"
      },
      {
        "name": "Suhana S",
        "branch": "CSE",
        "role": "Technology Consulting",
        "package": "7.5 LPA",
        "img": "/images/placements-page/placed_students/1nc22cs164.webp"
      },
      {
        "name": "Veghana N Gowda",
        "branch": "CSE - DS",
        "role": "Technology Consulting",
        "package": "7.5 LPA",
        "img": "/images/placements-page/placed_students/1nc22cd058.webp"
      },
      {
        "name": "Himanshi Sharma",
        "branch": "CSE",
        "role": "Technology Consulting",
        "package": "7.5 LPA",
        "img": "/images/placements-page/placed_students/1nc22cs060.webp"
      }
    ]
  },
  "o9": {
    "company": "O9",
    "logo": "/images/placements-page/company_logos/o9.webp",
    "studentCount": "5 Students Placed",
    "package": "9 LPA",
    "students": [
      {
        "name": "Jallapuram Sujith",
        "branch": "CSE - AI ML",
        "role": "Product Engineer",
        "package": "9 LPA",
        "img": null
      },
      {
        "name": "vyshnavi k",
        "branch": "CSE",
        "role": "Product Engineer",
        "package": "9 LPA",
        "img": null
      },
      {
        "name": "Sayed Asiruddin",
        "branch": "ECE",
        "role": "Product Engineer",
        "package": "9 LPA",
        "img": null
      },
      {
        "name": "Manoj kumar M",
        "branch": "CSE - DS",
        "role": "Product Engineer",
        "package": "9 LPA",
        "img": null
      },
      {
        "name": "Yashashwini K C",
        "branch": "CSE",
        "role": "Product Engineer",
        "package": "9 LPA",
        "img": null
      }
    ]
  },
  "deloitteus": {
    "company": "Deloitte US",
    "logo": "/images/placements-page/company_logos/deloitte.webp",
    "studentCount": "4 Students Placed",
    "package": "4.2 LPA",
    "students": [
      {
        "name": "MISBA KHANUM",
        "branch": "CSE - DS",
        "role": "Analyst Trainee",
        "package": "4.2 LPA",
        "img": null
      },
      {
        "name": "Rakesh Krishna",
        "branch": "ECE",
        "role": "Analyst Trainee",
        "package": "4.2 LPA",
        "img": null
      },
      {
        "name": "Bhargavi S M",
        "branch": "CSE",
        "role": "Analyst Trainee",
        "package": "4.2 LPA",
        "img": null
      },
      {
        "name": "Manoj M V",
        "branch": "CSE - DS",
        "role": "Analyst Trainee",
        "package": "4.2 LPA",
        "img": null
      }
    ]
  },
  "softsuave": {
    "company": "Soft Suave",
    "logo": "/images/placements-page/company_logos/soft-suave.webp",
    "studentCount": "2 Students Placed",
    "package": "3.5 LPA",
    "students": [
      {
        "name": "Rakshita R Danagoud",
        "branch": "CSE",
        "role": "Business Trainee",
        "package": "3.5 LPA",
        "img": null
      },
      {
        "name": "Bhoomika S",
        "branch": "CSE",
        "role": "Business Trainee",
        "package": "3.5 LPA",
        "img": null
      }
    ]
  },
  "evertz": {
    "company": "Evertz",
    "logo": "/images/placements-page/company_logos/evertz.webp",
    "studentCount": "1 Student Placed",
    "package": "5.5 LPA",
    "students": [
      {
        "name": "Megharaj T Shediyannanavar",
        "branch": "CSE",
        "role": "Software Engineer",
        "package": "5.5 LPA",
        "img": "/images/placements-page/placed_students/1nc22cs094.webp"
      }
    ]
  },
  "anasolconsultancy": {
    "company": "Anasol Consultancy",
    "logo": "/images/placements-page/company_logos/anasol.webp",
    "studentCount": "1 Student Placed",
    "package": "5 LPA",
    "students": [
      {
        "name": "Priyanka Chaurasiya",
        "branch": "CSE",
        "role": "Associate Software Engineer",
        "package": "5 LPA",
        "img": "/images/placements-page/placed_students/1nc22cs121.webp"
      }
    ]
  },
  "lavendelconsulting": {
    "company": "Lavendel Consulting",
    "logo": "/images/placements-page/company_logos/lavendel.webp",
    "studentCount": "1 Student Placed",
    "package": "12 LPA",
    "students": [
      {
        "name": "KANDULA KRISHNA REDDY",
        "branch": "CSE - AI ML",
        "role": "Configuration Engineer",
        "package": "12 LPA",
        "img": "/images/placements-page/placed_students/1nc22ci023.webp"
      }
    ]
  },
  "nokia": {
    "company": "Nokia",
    "logo": "/images/placements-page/company_logos/nokia.webp",
    "studentCount": "1 Student Placed",
    "package": "7 LPA",
    "students": [
      {
        "name": "Sathish R",
        "branch": "CSE - DS",
        "role": "Software Engineer",
        "package": "7 LPA",
        "img": "/images/placements-page/placed_students/1nc22cd046.webp"
      }
    ]
  },
  "teconnectivity": {
    "company": "TE Connectivity",
    "logo": "/images/placements-page/company_logos/te-connectivity.webp",
    "studentCount": "1 Student Placed",
    "package": "5 LPA",
    "students": [
      {
        "name": "Shashidhar S B",
        "branch": "ISE",
        "role": "Software Engineer",
        "package": "5 LPA",
        "img": "/images/placements-page/placed_students/shashidhar-sb.webp"
      }
    ]
  }
};

export default successStories;
